import { CompanyAccountModelDto } from '@treasury/api/channel';
import { SelectItemVm } from '@treasury/presentation/components/forms';

export interface SecCode {
    secCode: string;
    description: string;
}

export function mapAccountToVm(
    account: CompanyAccountModelDto
): SelectItemVm<CompanyAccountModelDto> {
    return {
        value: account,
        label: account.accountDisplayLabel ?? account.name,
    };
}

export function mapSecCodeToVm(secCode: SecCode): SelectItemVm<SecCode> {
    return {
        value: secCode,
        label: secCode.description,
    };
}
